import { useState } from 'react';
import { cn } from '@/shared/utils/cn';
import { usePopupHistory } from '@/shared/hooks/usePopupHistory';
import { BS_PROMISE_GRID_ITEMS } from '../data/bsPromises.data';
import { BsPromiseIcon } from './BsPromiseIcon';
import { BsPromisesSheet } from './BsPromisesSheet';

const GRID_CELL_CLASS: Record<(typeof BS_PROMISE_GRID_ITEMS)[number]['id'], string> = {
  refund: '',
  exchange: 'before:absolute before:bottom-0 before:left-0 before:h-[80%] before:w-px before:bg-[#e2e2e2]',
  certified: 'before:absolute before:right-0 before:top-0 before:h-px before:w-full before:bg-[#e2e2e2]',
  exclusive:
    'before:absolute before:left-0 before:top-0 before:h-px before:w-full before:bg-[#e2e2e2] after:absolute after:left-0 after:top-0 after:h-[80%] after:w-px after:bg-[#e2e2e2]',
};

export function BsPromises({ onKnowMoreClick }: { onKnowMoreClick?: () => void }) {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const handleCloseSheet = () => {
    setIsSheetOpen(false);
  };

  const { goBack } = usePopupHistory({
    isOpen: isSheetOpen,
    onClose: handleCloseSheet,
    stateKey: 'bspromise',
  });

  const handleKnowMore = () => {
    onKnowMoreClick?.();
    setIsSheetOpen(true);
  };

  return (
    <>
      <div>
        <div className="px-[15px] py-[15px]">
          <h3 className="text-[15px] font-semibold text-black">BlueStone Promise</h3>
        </div>

        <div className="grid grid-cols-2 px-[15px] pb-1">
          {BS_PROMISE_GRID_ITEMS.map((item) => (
            <div
              key={item.id}
              className={cn(
                'relative px-2.5 pb-5 pt-7 text-center text-xs leading-[18px] text-black',
                GRID_CELL_CLASS[item.id]
              )}
            >
              <div className="mb-0.5 flex justify-center">
                <BsPromiseIcon iconId={item.id} />
              </div>
              <p className="text-xs font-bold uppercase leading-4">
                {item.titleLines.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>
              <p className="mt-1 text-xs font-normal leading-4 text-black">
                {item.descriptionLines.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>
            </div>
          ))}
        </div>

        <div className="border-t border-[#e2e2e2] text-center">
          <button
            type="button"
            onClick={handleKnowMore}
            className="w-full px-4 py-[15px] text-sm font-normal text-[var(--link-blue)]"
          >
            Know more
          </button>
        </div>
      </div>

      <BsPromisesSheet open={isSheetOpen} onClose={goBack} />
    </>
  );
}
